import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { Stack, Autocomplete, TextField } from '@mui/material';

function EditStudentModal(props) {

    const [projects, setProjects] = useState([]);
    const [student, setStudent] = useState(props.student);
    const [currentTeam, setCurrentTeam] = useState();
    const [newTeam, setNewTeam] = useState();

    const handleTeamChange = (event, value) => {
        setNewTeam(value);
    };

    function handleSubmit(event) {
        event.preventDefault();
        if (currentTeam.name !== newTeam.name) {
            props.handleChangeGroup(student.user_id, newTeam);
        }
        props.handleClose();
    }

    useEffect(() => {
        setProjects(props.projects);
    }, [props.projects]);

    useEffect(() => {
        let team = props.projects.find((project) => project.group_id === 1685);
        setCurrentTeam(team);
        setNewTeam(team);
    }, [props.currentTeam]);

    useEffect(() => {
        setStudent(props.student);
    }, [props.student]);

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        width: "60%",
        maxWidth: 550,
        minWidth: 300,
        maxHeight: 650,
        p: 3,
        borderRadius: 1,
        boxShadow: 24,
        overflowX: "auto",
    };

    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
        >
            <Box sx={modalStyle}>
                <Stack spacing={1} component='form' onSubmit={handleSubmit}>
                    <Typography variant='h4'>Edit Student</Typography>
                    <Stack direction='column' justifyContent='flex-end'>
                        <Typography variant='h6'>{student.first_name + ' ' + student.last_name}</Typography>
                        <TextField variant='standard' label='Current team' disabled defaultValue={currentTeam ? currentTeam.name: ""} style={{margin: 0}}/>
                        <Autocomplete
                            id='start-semester'
                            options={projects}
                            value={newTeam}
                            disabled={props.currentTeam == null}
                            getOptionLabel={(option) => option.name}
                            isOptionEqualToValue={(option, value) => option.group_id === value.group_id}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            autoHighlight
                            autoSelect
                            fullWidth
                            onChange={handleTeamChange}
                            renderInput={(params) => (
                                <TextField {...params} label='New Team' variant='standard'/>
                            )}
                        />
                        {props.currentTeam == null && <Typography style={{marginBlock: "10px"}}>Cannot change students group until groups have been formed</Typography>}
                    </Stack>
                    <Stack direction='row' spacing={2} justifyContent='center'>
                        <Button variant='outlined' onClick={props.handleClose} fullWidth>Cancel</Button>
                        <Button variant='contained' type='submit' color='primary' fullWidth>Submit</Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
}

export default EditStudentModal;